
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IUserState } from '../../store/contract';
import OffcanvasMenu from './OffcanvasMenu.vue';
import JoeyBrandName from '../branding/JoeyBrandName.vue';
import JoeyLogo from '../branding/JoeyLogo.vue';
import SearchBar from '../searchBar/SearchBar.vue';

const namespace: string = 'user';

@Component({
    components: {
        OffcanvasMenu,
        JoeyBrandName,
        JoeyLogo,
        SearchBar
    }
})
export default class TopNavbar extends Vue {
    @State(namespace) userState: IUserState;
}
